<div class="dialog-body">
    <div class="row">
        <div class="col-md-12 text-center title">
            {{data.infoSubSystem.fullname | substring: 30}} - Khách hàng
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                        <span class="font">
                                    Tổng số: {{dataSource.length}} khách hàng
                               </span>
                </div>

                <div class="col-md-12 d-flex justify-content-center">
                    <input (keydown)="keyPressSearch($event)" type="text" class="form-control" id="inputSearch" aria-describedby="emailHelp"
                           placeholder="Tìm kiếm theo Tên khách hàng, Mã khách hàng, Tên miền, Số điện thoại hoặc Email">
                </div>
                <img style="position: relative; left: 30px; bottom: 30px; cursor: pointer" src="assets/images/svg/search.svg" alt="">
            </div>
        </div>
    </div>

    <div class="container-fluid custom-scroll">
        <table mat-table [dataSource]="dataSource" class="table-el">

            <ng-container matColumnDef="stt">
                <th mat-header-cell *matHeaderCellDef> STT</th>
                <td class="border-first-5" mat-cell *matCellDef="let element, let i = index"> {{i + 1}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="fullname">
                <th mat-header-cell *matHeaderCellDef> Khách hàng</th>
                <td mat-cell *matCellDef="let element">
                    {{element.fullname}}
                </td>
            </ng-container>

            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef> Mã</th>
                <td mat-cell *matCellDef="let element"> {{element.code}} </td>
            </ng-container>

            <ng-container matColumnDef="domain">
                <th mat-header-cell *matHeaderCellDef> Tên miền</th>
                <td mat-cell *matCellDef="let element">
                    {{element.tenantUrl}}
                </td>
            </ng-container>

            <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef> SĐT</th>
                <td mat-cell *matCellDef="let element">
                    {{element.phone}}
                </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let element">
                    {{element.email}}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
<br>
<p class="text-center">
    <button mat-dialog-close class="btn btn-close">Đóng</button>
</p>
